module.exports = __webpack_public_path__ + "img/alarm.8ff6b3b7.svg";